var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountProfile = function SvgIconAccountProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.001 17.334a8.333 8.333 0 1 1 0-16.667 8.333 8.333 0 0 1 0 16.667m0-1.667a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333m0-10a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667m0 3.333a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 2.5c-.92 0-1.666.746-1.666 1.667H5.668a3.333 3.333 0 0 1 6.667 0h-1.667c0-.92-.746-1.667-1.667-1.667"
  })));
};
export default SvgIconAccountProfile;